import React from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import bindAll from 'lodash.bindall';
import { setPlayer } from "../../..";
import {
    doneUpdatingProject,
    manualUpdateProject,
    onLoadedProject,
    reloadProject,
    saveProjectAsCopy,
    setProjectId, setProjectIdSilent
} from '../../../reducers/project-state';
import WrappedGui from "../wrapped-gui/wrapped-gui";
import TaskProgressBar from '../task-progress-bar';
import { saveTaskRecord } from "../../api/task-record";
import ModalManager from "../modal/modal-manager";
import { renderConfirmModal } from "../confirm-modal/confirm-modal";
import showMsg from "../../guide/actions/show-msg";
import { GUIDE_MODE, TASK_PROGRESS_DONE, ZINDEX_SYSTEM_BTN } from '../../lib/constant';
import clickElement from "../../guide/actions/click-element";
import event, { EVENTS } from "../../lib/event";
import Cartoon from '../../guide/avatar-action';
import { getProjectInfo } from '../../api/project';
import SaveStatus from '../../../components/menu-bar/save-status';
import { headNavBack } from '../../lib/utils';
import { withRouter } from 'react-router-dom';
import styles from './styles.scss';
import down from './down.png';

class TaskProgram extends React.PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleLoadedProject',
            'handleUpdatedProject',
            'reiniProgramProject',
            'handleNavBack',
            'save'
        ]);
        props.setPlayer(false); //确保为非Player模式
    }

    componentDidMount() {
        event.on(EVENTS.INIT_PROGRAM_TASK, this.reiniProgramProject);
        event.on(EVENTS.NAV_BACK, this.handleNavBack);
        event.on(EVENTS.TASK_SAVE, this.save);
        const { task } = this.props;
        if (task.record.modified_project_id) { //先检查项目是否被删除
            getProjectInfo({ id: task.record.modified_project_id }).then(r => {
                this.props.setProjectId(task.record.modified_project_id.toString());
            }, e => { //项目被删除的情况
                if (e.code === -1) {
                    this.reiniProgramProject();
                }
            });
        } else {
            this.props.setProjectId(task.project_id.toString());
        }
    }

    componentWillUnmount() {
        event.off(EVENTS.INIT_PROGRAM_TASK, this.reiniProgramProject);
        event.off(EVENTS.NAV_BACK, this.handleNavBack);
        event.off(EVENTS.TASK_SAVE, this.save);
        Cartoon.initState();
        ModalManager.closeAll();
    }

    /**
     * 退出课程按钮被点击
     */
    handleNavBack() {
        this.isNavBackCalled = true;
        if (this.props.projectChanged) {
            this.save();
        } else {
            headNavBack(this.props.history);
        }
    }


    //重新初始化练习模式的项目
    reiniProgramProject() {
        //this.props.task.record.modified_project_id = 0;
        this.props.setProjectId(this.props.task.project_id.toString());
    }



    componentDidUpdate(prevProps, prevState, snapshot) {
        const { task } = this.props;
        if (task.project_id != this.props.projectId && this.props.projectId
            && this.props.projectId != prevProps.projectId
            && task.record.modified_project_id != this.props.projectId) {
            //保存副本后，更新record
            task.record.modified_project_id = this.props.projectId;
            saveTaskRecord(task.record);
            this.forceUpdate();
        }
    }


    handleLoadedProject(loadingState, canSave) {
        const { task } = this.props;
        // console.log('handleLoadedProject: ' + this.props.projectId);
        if (!this.props.isCheck && task.record.progress != TASK_PROGRESS_DONE) {
            showMsg({
                title: task.name,
                msg: task.desc
            }).finally(() => {
                clickElement({
                    element: '[class*="lesson_completeTask"]',
                    zIndex: 10000,
                    noModal: true,
                    tips: '完成作品后，点击这里提交。'
                }).catch(e => { });
            }).catch(e => { });;
        }
        this.props.onLoadedProject(loadingState, canSave);

    }

    /**
     * 项目被保存时触发
     * @param loadingState
     */
    handleUpdatedProject(loadingState) {
        this.props.onUpdatedProject(loadingState);
        if (this.isNavBackCalled) {
            //这里执行真正的返回
            headNavBack(this.props.history)
        }
    }

    save() {
        if (this.props.task.project_id == this.props.projectId) { //尚未创建副本
            if (this.props.task.record.modified_project_id != 0) {
                this.props.setProjectIdSilent(this.props.task.record.modified_project_id.toString());
                this.props.saveProject();
            } else {
                this.props.saveProjectAsCopy();
            }
        } else { //直接保存副本
            this.props.saveProject();
        }
    }

    render() {
        const { task, currentTaskId, homeworkBeginTask, lessonProgress, currentLesson, onRate, isCheck,currentMember } = this.props;

        let fraction = null
        if (currentLesson.record && currentLesson.record.rate) {
            if (currentLesson.record.rate == '1') {
                fraction = '未通过'
            }
            if (currentLesson.record.rate == '3') {
                fraction = 'D'
            }
            if (currentLesson.record.rate == '6') {
                fraction = 'C'
            }
            if (currentLesson.record.rate == '8') {
                fraction = 'B'
            }
            if (currentLesson.record.rate == '10') {
                fraction = 'A'
            }
        }
        return (
            <div>
                <div
                    style={{
                        width: 'calc(100vw - 644px)',
                        minWidth: 380,
                        height: 48,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'absolute',
                        paddingLeft: 16,
                        marginLeft: 380,
                        top: 0,
                        zIndex: ZINDEX_SYSTEM_BTN
                    }}>
                    {
                        isCheck &&
                        <div onClick={() => this.handleCorrect(currentLesson)} className={styles.member}>
                            <span>{currentMember}</span>
                            <img src={down}></img>
                        </div>
                    }
                    <TaskProgressBar
                        currentTaskId={currentTaskId}
                        homeworkBeginTask={homeworkBeginTask}
                        lessonProgress={lessonProgress}
                        onSelect={this.props.onSelect}
                    />
                    {
                        isCheck &&
                        <div onClick={onRate} className={styles.rateBtn}>
                            <span>
                                {fraction ? `评分${fraction}` : window.L('teach.lesson.unCommented')}
                            </span>
                        </div>
                    }
                    {
                        !isCheck && currentLesson.record && currentLesson.record.rate &&
                        <div className={styles.rateBtn} onClick={onRate}>
                            <span>
                                {fraction ? `评分${fraction}` : window.L('teach.lesson.unCommented')}
                            </span>
                        </div>
                    }
                    <SaveStatus isInTask={lessonProgress.length > 0 ? true : false} />
                </div>
                <WrappedGui
                    //projectId={this.props.projectId}
                    canSave={this.props.task && this.props.task.record && this.props.task.record.modified_project_id && this.props.task.record.modified_project_id == this.props.projectId} //标准程序不允许保存，但是如果保存为副本后可以支持保存
                    autoSave={this.props.task && this.props.task.record && this.props.task.record.modified_project_id && this.props.task.record.modified_project_id == this.props.projectId}
                    enableCommunity={false}
                    canShare={false}
                    onLoadedProject={this.handleLoadedProject}
                    isProgramTask={1}
                    // canEditTitle={false}
                    onUpdatedProject={this.handleUpdatedProject}
                />
            </div>
        );
    }
}

TaskProgram.propTypes = {
    task: PropTypes.object,
    onTaskUpdate: PropTypes.func,
    onTaskComplete: PropTypes.func,
    onNext: PropTypes.func,
    onRestudy: PropTypes.func,
    setProjectId: PropTypes.func,
    reloadProject: PropTypes.func,
    projectId: PropTypes.string,
    onLoadedProject: PropTypes.func,
    onUpdatedProject: PropTypes.func,
    setPlayer: PropTypes.func,
    saveProject: PropTypes.func,
    saveProjectAsCopy: PropTypes.func,
    onSelect: PropTypes.func,
    isCheck: PropTypes.bool,
    projectChanged: PropTypes.bool,
    setProjectIdSilent: PropTypes.func,
}

const mapStateToProps = state => ({
    projectId: state.scratchGui.projectState.projectId,
    projectChanged: state.scratchGui.projectChanged,
});
const mapDispatchToProps = dispatch => ({
    setProjectId: projectId => dispatch(setProjectId(projectId)),
    reloadProject: () => dispatch(reloadProject()),
    onLoadedProject: (loadingState, canSave) => dispatch(onLoadedProject(loadingState, canSave, true)),
    onUpdatedProject: loadingState => dispatch(doneUpdatingProject(loadingState)),
    setPlayer: isPlayerOnly => dispatch(setPlayer(isPlayerOnly)),
    saveProject: () => dispatch(manualUpdateProject()),
    saveProjectAsCopy: () => dispatch(saveProjectAsCopy()),
    setProjectIdSilent: projectId => dispatch(setProjectIdSilent(projectId)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TaskProgram));
